<section>
  <header class="section-header">
    <!-- titre de la section -->
    <h3 class="section-title" #title>
      <ng-content select="[slot='title']"></ng-content>
    </h3>
  </header>

  <div class="section-main">
    <!-- contenu de la section -->
    <ng-content></ng-content>
  </div>
</section>
